document.addEventListener('DOMContentLoaded', () => {

  const root = document.getElementById('sg-floor-widget');
  if (!root) return;

  const lampWidth =
    parseFloat(root.dataset.width) || 12;

  const lampHeight =
    parseFloat(root.dataset.height) || 60;

  root.innerHTML = `
    <div class="sg-floor-wrap">

      <h2>Will This Floor Lamp Fit My Space?</h2>

      <p class="sg-floor-desc">
        Compare floor lamp size with your sofa and room corner.
      </p>

      <div class="sg-floor-grid">

        <div class="sg-floor-box">
          <label>Corner width</label>
          <input id="cornerWidth" type="number" value="48">
        </div>

        <div class="sg-floor-box">
          <label>Ceiling height</label>
          <input id="ceilingHeight" type="number" value="96">
        </div>

        <div class="sg-floor-box">
          <label>Sofa height</label>
          <input id="sofaHeight" type="number" value="34">
        </div>

      </div>

      <div class="sg-floor-scene" id="scene"></div>

    </div>
  `;

  const inputs = root.querySelectorAll('input');

  inputs.forEach(i=>{
    i.addEventListener('input',render);
  });

  render();

  function render(){

    const corner =
      parseFloat(document.getElementById('cornerWidth').value)||48;

    const ceiling =
      parseFloat(document.getElementById('ceilingHeight').value)||96;

    const sofa =
      parseFloat(document.getElementById('sofaHeight').value)||34;

    const scene =
      document.getElementById('scene');

    const roomScale =
      320 / ceiling;

    const roomH =
      ceiling * roomScale;

    const roomW =
      corner * roomScale;

    const sofaH =
      sofa * roomScale;

    const lampH =
      lampHeight * roomScale;

    const lampW =
      lampWidth * roomScale;

scene.innerHTML = `
  <div class="sg-floor-room"
       style="
         width:${roomW}px;
         height:${roomH}px;
       ">

    <div class="sg-floor-sofa"
         style="
           width:${roomW*0.45}px;
           height:${sofaH}px;
         ">
    </div>

    <div class="sg-floor-lamp">

      <div class="sg-floor-shade"
           style="
             width:${lampW}px;
             height:${lampW}px;
           ">
      </div>

      <div class="sg-floor-pole"
           style="
             height:${lampH-lampW}px;
           ">
      </div>

    </div>

    <div class="sg-floor-label sg-floor-room-label">
      Corner ${corner} in × Ceiling ${ceiling} in
    </div>

    <div class="sg-floor-label sg-floor-lamp-label"
         style="bottom:${lampH + 8}px; left:60%;">
      Lamp ${lampWidth} in × ${lampHeight} in
    </div>

    <div class="sg-floor-label sg-floor-sofa-label"
         style="bottom:${sofaH + 8}px; left:50%;">
      Sofa height ${sofa} in
    </div>

  </div>
    `;
  }

});